import React, { useState, useEffect } from "react";
import "./SettingsPage.css";

export default function SettingsPage() {
  const defaultSettings = {
    useGPS: true,
    defaultLat: 8.7642, // Thoothukudi
    defaultLng: 78.1348,
    mapStyle: "osm", // options: osm, satellite, dark
    showSunpath: true,
    showShadows: false,
    zoomLevel: 10,
    utcOffset: new Date().getTimezoneOffset() / -60,
  };

  const [settings, setSettings] = useState(defaultSettings);

  // Load from localStorage
  useEffect(() => {
    const saved = localStorage.getItem("solarSettings");
    if (saved) setSettings(JSON.parse(saved));
  }, []);

  // Update and persist settings
  const updateSetting = (key, value) => {
    const updated = { ...settings, [key]: value };
    setSettings(updated);
    localStorage.setItem("solarSettings", JSON.stringify(updated));
  };

  // Reset settings to defaults
  const resetSettings = () => {
    setSettings(defaultSettings);
    localStorage.setItem("solarSettings", JSON.stringify(defaultSettings));
  };

  return (
    <div className="settings-page">
      <div className="settings-header">
        <h2>Settings</h2>
        <button onClick={resetSettings}>Reset to Defaults</button>
      </div>

      <div className="settings-section">
        <h3>Map Preferences</h3>
        <label>Default Location</label>
        <input
          type="text"
          value={`Thoothukudi (${settings.defaultLat}, ${settings.defaultLng})`}
          readOnly
        />

        <label>Zoom Level</label>
        <select
          value={settings.zoomLevel}
          onChange={(e) => updateSetting("zoomLevel", parseInt(e.target.value))}
        >
          <option value={8}>8 - Region View</option>
          <option value={10}>10 - City View</option>
          <option value={14}>14 - Street View</option>
        </select>
      </div>

      <div className="settings-section">
        <h3>Display Options</h3>
        <label>
          <input
            type="checkbox"
            checked={settings.showSunpath}
            onChange={(e) => updateSetting("showSunpath", e.target.checked)}
          />
          Show Sunpath
        </label>
        <label>
          <input
            type="checkbox"
            checked={settings.showShadows}
            onChange={(e) => updateSetting("showShadows", e.target.checked)}
          />
          Show Shadows
        </label>
      </div>

      <div className="settings-save">
        <button onClick={() => alert("✅ Settings Saved!")}>
          Save Changes
        </button>
      </div>
    </div>
  );
}
